<template>
	<v-dialog class="dialog" width="550" v-model="mutableDialog">
		<v-card class="pa-6">
			<div class="d-flex justify-space-between mb-3">
				<v-text-field
					v-model="taskName"
					outlined
					dense
					hide-details
					append-icon="$edit-input"
				>
				</v-text-field>

				<v-spacer></v-spacer>

				<v-btn icon @click="mutableDialog = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>

			<tag-menu
				v-if="!taskOwner || taskOwner === $store.state.auth.user.id"
				@selectTag="selectTag($event)"
			/>

			<div v-if="!taskOwner || taskOwner === $store.state.auth.user.id">
				<tag
					@removeTag="removeTag($event)"
					:key="tag.id"
					v-for="tag in selectedTags"
					:tagName="tag.name"
					:color="tag.color"
					:id="tag.id"
				/>
			</div>

			<label class="dialogLabel subtitle-2 font-weight-medium mt-4 mb-1">
				{{
					$vuetify.lang.t(
						"$vuetify.views.tasks.taskEditDialog.deadline"
					)
				}}
			</label>
			<date-time-picker
				@selected="selectData($event)"
				:isSecondary="true"
				class="date-picker"
			/>

			<div v-if="!taskOwner || taskOwner === $store.state.auth.user.id">
				<label
					class="dialogLabel subtitle-2 font-weight-medium mt-4 mb-1"
				>
					{{
						$vuetify.lang.t(
							"$vuetify.views.tasks.taskEditDialog.onList"
						)
					}}
				</label>
				<v-menu bottom offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							height="28"
							class="select-btn mr-2 mb-2"
							color="background lighten-1"
						>
							{{ selectedList ? selectedList.name : "Wybierz" }}
							<v-icon>mdi-chevron-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							:key="list.id"
							v-for="list in lists"
							class="list-item subtitle-2"
							link
							@click="selectedList = list"
						>
							{{ list.name }}
						</v-list-item>
					</v-list>
				</v-menu>
			</div>

			<label class="dialogLabel subtitle-2 font-weight-medium mt-4">
				{{
					$vuetify.lang.t(
						"$vuetify.views.tasks.taskEditDialog.priorityName"
					)
				}}
			</label>

			<v-radio-group v-model="priority" row class="mt-1">
				<v-radio value="null" :ripple="false">
					<template v-slot:label>
						<span>
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.taskEditDialog.priority.lack"
								)
							}}
						</span>
					</template>
				</v-radio>
				<v-radio value="low" :ripple="false">
					<template v-slot:label>
						<priority class="low-priority">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.taskEditDialog.priority.low"
								)
							}}
						</priority>
					</template>
				</v-radio>

				<v-radio value="medium" :ripple="false">
					<template v-slot:label>
						<priority class="medium-priority">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.taskEditDialog.priority.medium"
								)
							}}
						</priority>
					</template>
				</v-radio>

				<v-radio value="high" :ripple="false">
					<template v-slot:label>
						<priority class="high-priority">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.taskEditDialog.priority.hight"
								)
							}}
						</priority>
					</template>
				</v-radio>
			</v-radio-group>

			<label class="dialogLabel subtitle-2 font-weight-medium mb-2">
				{{
					$vuetify.lang.t(
						"$vuetify.views.tasks.taskEditDialog.assignTask"
					)
				}}
			</label>

			<search-user @selectUser="(id) => (taskOwner = id)" />

			<div class="d-flex align-center">
				<v-btn
					@click="$refs.attachments.dialog = true"
					height="40"
					color="secondary"
					elevation="0"
					class="d-block mt-4"
				>
					<v-icon class="mr-2">$upload</v-icon>
					{{
						$vuetify.lang.t(
							"$vuetify.views.tasks.taskEditDialog.addAtachement"
						)
					}}
				</v-btn>

				<div
					:key="attachment_tokens[i]"
					v-for="(f, i) in attachments"
					class="d-flex align-center"
				>
					<v-btn
						elevation="0"
						height="40"
						class="mt-4 ml-2 att-btn"
						:href="attachment_url[i]"
						outlined
						color="grey lighten-3"
					>
						<v-icon class="mr-1">$attachment</v-icon> {{ f.name }}
					</v-btn>
					<v-btn
						@click.prevent="removeAtt(i)"
						class="ml-1 mt-4"
						elevation="0"
						x-small
						icon
					>
						<v-icon> $delete </v-icon>
					</v-btn>
				</div>
			</div>

			<label class="dialogLabel subtitle-2 font-weight-medium mt-4 mb-2">
				{{
					$vuetify.lang.t(
						"$vuetify.views.tasks.taskEditDialog.taskList"
					)
				}}
			</label>

			<v-checkbox
				:key="i"
				v-for="(taskItem, i) in taskItems"
				:label="taskItem.name"
				:checked="taskItem.is_finished"
				color="accent"
				class="pa-0 ma-0 checkbox"
				@change="taskItem.is_finished = !taskItem.is_finished"
				:ripple="false"
			></v-checkbox>

			<v-btn
				height="32"
				color="secondary"
				elevation="0"
				class="mt-3"
				@click.stop="activeAddTaskForm()"
				v-if="!addTaskInputVisible"
			>
				+
				{{
					$vuetify.lang.t(
						"$vuetify.views.tasks.taskEditDialog.addNewPosition"
					)
				}}
			</v-btn>
			<div
				class="d-flex mt-3"
				v-click-outside="deactiveAddTaskForm"
				v-else
			>
				<v-text-field
					:placeholder="
						$vuetify.lang.t(
							'$vuetify.views.tasks.taskEditDialog.addTask'
						)
					"
					outlined
					dense
					hide-details
					class="input-text subtitle-2 font-weight-medium"
					v-model="taskItemTitle"
					@keydown.enter.prevent="addTaskItem()"
				>
				</v-text-field>

				<v-btn
					@click="addTaskItem()"
					height="32"
					color="secondary"
					elevation="0"
					class="ml-3"
				>
					{{
						$vuetify.lang.t(
							"$vuetify.views.tasks.taskEditDialog.addNewPosition"
						)
					}}
				</v-btn>
			</div>

			<label class="notes d-block subtitle-2 font-weight-bold mt-5 mb-2">
				{{
					$vuetify.lang.t("$vuetify.views.tasks.taskEditDialog.notes")
				}}
				<span class="font-weight-medium">
					({{
						$vuetify.lang.t(
							"$vuetify.views.tasks.taskEditDialog.optional"
						)
					}})
				</span>
			</label>

			<v-text-field
				:placeholder="
					$vuetify.lang.t(
						'$vuetify.views.tasks.taskEditDialog.addNote'
					)
				"
				outlined
				hide-details
				dense
				class="mr-3 subtitle-2 font-weight-medium"
				v-model="notes"
			>
			</v-text-field>

			<div class="d-flex mt-6">
				<v-spacer></v-spacer>

				<v-btn
					@click="addTask()"
					height="40"
					elevation="0"
					color="accent"
					class="subtitle-1"
				>
					{{
						$vuetify.lang.t("$vuetify.views.tasks.addNewTask.save")
					}}
				</v-btn>
			</div>
		</v-card>

		<attach-attachments-dialog
			@selected="selectAttachement"
			ref="attachments"
		/>
	</v-dialog>
</template>

<script>
import ClickOutside from "vue-click-outside";

import DateTimePicker from "@/components/pickers/DateTimePicker";
import Priority from "@/components/tasks/Priority";
import SearchUser from "@/components/tasks/SearchUser.vue";
import Tag from "@/components/tasks/Tag.vue";
import TagMenu from "@/components/tasks/TagMenu.vue";

import AttachAttachmentsDialog from "@/components/wall/dialogs/AttachAttachmentsDialog";

import { mapGetters } from "vuex";
import axios from "axios";

export default {
	components: {
		DateTimePicker,
		Priority,
		Tag,
		TagMenu,
		AttachAttachmentsDialog,
		SearchUser,
	},
	props: {
		dialog: Boolean,
		type: {
			type: String,
			default: "edit",
		},
		taskTitle: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			mutableDialog: this.dialog,
			priority: "",
			addTaskInputVisible: false,
			taskName: this.taskTitle,
			deadline: "",
			selectedList: "",
			taskItems: [],
			taskItemTitle: "",
			notes: "",
			taskOwner: "",
			selectedTags: [],
			attachment_tokens: [],
			attachment_id: [],
			attachments: [],
			attachment_url: [],
		};
	},

	computed: {
		...mapGetters({
			lists: "tasks/lists",
		}),
	},

	methods: {
		activeAddTaskForm() {
			this.addTaskInputVisible = true;
		},

		deactiveAddTaskForm() {
			this.addTaskInputVisible = false;
		},

		selectTag(tags) {
			this.selectedTags = tags;
		},

		removeTag(tagID) {
			const idx = this.selectedTags.findIndex((tag) => tag.id === tagID);
			this.selectedTags.splice(idx, 1);
		},

		selectData(data) {
			if (data) {
				this.deadline = this.$moment(data)
					.parseZone()
					.format("YYYY-MM-DD HH:mm:ss");
			} else {
				this.deadline = null;
			}
		},

		addTask() {
			if (this.taskName) {
				const params = {
					user_id: this.taskOwner || this.$store.state.auth.user.id,
					title: this.taskName,
					deadline: this.deadline,
					status: "unfinished",
					task_list_id: !this.taskOwner ? this.selectedList.id : null,
					priority: this.priority,
					notes: this.notes,
					taskItems: this.taskItems,
					tags: this.selectedTags.map((tag) => tag.id),
					attachment_tokens: this.attachment_tokens,
				};

				params.creator_user_id =
					params.user_id === this.$store.state.auth.user.id
						? null
						: this.$store.state.auth.user.id;

				if (params.creator_user_id) {
					params.tags = null;
					params.task_list_id = null;
				}

				this.$emit("addTask", {
					params,
					taskItems: this.taskItems,
				});

				this.priority = "";
				this.taskName = "";
				this.deadline = "";
				this.selectedList = null;
				this.taskItems = [];
				this.taskItemTitle = "";
				this.notes = "";
				this.taskOwner = "";
				this.selectedTags = [];
				this.attachment_tokens = [];
				this.attachments = [];
				this.attachment_url = [];
				this.attachment_id = [];

				this.mutableDialog = false;
			}
		},

		addTaskItem() {
			if (this.taskItemTitle) {
				const taskItem = {
					name: this.taskItemTitle,
					is_finished: false,
				};
				this.taskItems.push(taskItem);
				this.taskItemTitle = "";
			}
		},

		cancelNotes() {
			this.notes = "";
			this.isNotesEditing = true;
		},

		selectAttachement(files) {
			files = Array.from(files);

			files.map((item) => {
				if (!this.attachments.find((x) => x.name == item.name)) {
					this.attachments[this.attachments.length] = item;
					this.attachments = Object.assign([], this.attachments);
					this.sendAttachements(item);
				}
			});
		},

		async sendAttachements(item) {
			let formData = new FormData();
			formData.append("file", item);
			formData.append("type", "attachment");
			formData.append("for", "task_attachment");

			await axios
				.post("files", formData)
				.then((response) => {
					this.attachment_tokens.push(response.data.data.token);
					this.attachment_id.push(response.data.data.id);
					this.attachment_url.push(response.data.data.url_download);
				})
				.catch((error) => {
					console.log("POST FILE ERROR", error);
				});
		},

		async removeAtt(idx) {
			const id = this.attachment_id[idx];
			await this.deleteAttachement(id);

			this.attachments.splice(idx, 1);
			this.attachment_url.splice(idx, 1);
			this.attachment_tokens.splice(idx, 1);
			this.attachment_id.splice(idx, 1);
		},

		async deleteAttachement(id) {
			await axios
				.delete(`files/${id}`)
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					console.log("DELETE FILE ERROR", error);
				});
		},
	},
	watch: {
		dialog() {
			this.mutableDialog = this.dialog;
		},

		mutableDialog(oldValue) {
			if (oldValue === false) {
				this.$emit("closeDialog");

				if (this.attachment_tokens) {
					this.attachment_id.forEach((id) => {
						this.deleteAttachement(id);
					});
				}
			}
		},
	},

	directives: {
		ClickOutside,
	},
};
</script>

<style lang="scss" scoped>
.v-dialog__content {
	justify-content: flex-end;
}

.dialogLabel {
	display: block;
	color: var(--v-grey-darken2);
}

.inputColor {
	color: var(--v-grey-darken3);
}

.v-btn--icon.v-size--small,
.v-btn--icon.v-size--small .v-icon,
.v-btn--fab.v-size--small .v-icon {
	width: max-content;
	height: max-content;
}

label.v-label.theme--light * {
	font-size: 14px;
	letter-spacing: 0.2px;
	color: var(--v-grey-darken2);
}

.checkbox {
	width: max-content;
}

.notes {
	color: var(--v-grey-darken2);

	span {
		color: var(--v-grey-lighten5);
	}
}

.v-input.mr-3.v-input--hide-details.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--placeholder {
	margin: 0 !important;
}

.list-item {
	min-height: 32px;
}

.btn-icon {
	width: 40px;
}

.att-btn {
	span.v-btn__content {
		color: var(--v-grey-base);
	}
}
</style>

<style lang="scss">
.att-btn {
	span.v-btn__content {
		color: var(--v-grey-base);
	}
}
</style>
